<template>
  <AiChat :open="visible" ref="aiChat" @on-close="commonCancel" @on-insert="onInsert" :aiShow="false" :title="nodeDetail && nodeDetail.id ? '编辑LLM节点' : '增加LLM节点'">
    <div class="common-container">
      <Form style="width: 100%" :model="formData" ref="form" :label-width="110" :rules="ruleValidate">
        <FormItem label="节点名称" prop="name">
          <Input v-model="formData.name" style="width: 300px" placeholder="" />
        </FormItem>
        <!-- <FormItem label="模型" prop="model">
          <Input v-model="formData.model" style="width: 300px" placeholder="" />
        </FormItem>
        <FormItem label="提示语" prop="prompt">
          <Input v-model="formData.prompt" style="width: 300px" placeholder="" />
        </FormItem> -->
        <FormItem label="是否对话模式" prop="dialog">
          <i-switch v-model="formData.dialog"/>
        </FormItem>
        <!-- 是否支持打断 -->
        <form-item-can-break :formItemProps="{ prop: 'can_break' }" v-model="formData.can_break"/>
        <FormItem label="前">
          <InputNumber v-model="formData.break_delay" :min="0"  :disabled="!formData.can_break"/><span style="margin-left: 5px">ms不打断</span>
        </FormItem>
        <FormItem label="延迟播放">
          <InputNumber v-model="formData.playback_delay" :min="0" /><span style="margin-left: 5px">ms</span>
        </FormItem>
        <FormItem label="等待响应超时时长">
          <InputNumber v-model="formData.input_timeout" :min="0" /><span style="margin-left: 5px">ms</span>
        </FormItem>
        <form-item-tag :formItemProps="{ prop: 'tag' }" v-model="formData.tag"/>
        <form-item-var :formItemProps="{ prop: 'vars' }" v-model="formData.vars"/>
        <div class="btn">
          <Button style="margin-right: 20px" color="#547ed1" @click="commonCancel">取消</Button>
          <Button
            type="primary"
            style="margin-right: 20px"
            color="#547ed1"
            @click="submitCommon"
            >确定</Button
          >
        </div>
      </Form>
    </div>
  </AiChat>
</template>
<script>
import FormItemVar from '@/components/FormItemVar.vue';
import FormItemTag from '@/components/FormItemTag.vue';
import cloneDeep from 'lodash/cloneDeep'
import FormItemCanBreak from '../../../components/FormItemCanBreak.vue';
import { addNodeId } from '@/utils/nodeIdPool';
import AiChat from '@/views/aiChat/index'

export default {
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: ['visible', 'nodeDetail'],
  components: {
    FormItemVar,
    FormItemTag,
    FormItemCanBreak,
    AiChat
  },
  data() {
    const validatedtmfTerminator = (rule, value, callback) => {
        if(value === '') {
          callback()
        } else if (value.lenth > 1) {
            callback(new Error('只支持1位'))
        } else if (!['0','1','2','3','4','5','6','7','8','0','*','#'].includes(value)) {
            callback(new Error('只支持0-9、*、#'))
        } else {
            callback()
        }
    }
    return {
      showBranchModal: false,
      formData: {
        name: '',
        model: '',
        prompt: '',
        dialog: false,
        can_break: true,
        break_delay: 0,
				playback_delay: 0,
        input_timeout: 0,
				tag: '',
				vars: [],
      },
      ruleValidate: {
        name: [
          { required: true, message: '节点名不能为空', trigger: 'blur' },
        ],
      },
      insertConf: {
        type: '',
        index: 0,
      }
    };
  },
	watch: {
		nodeDetail(val) {
			if (!val) {
        this.resetFormData();
        return;
      }
      const formData = {
        ...this.formData,
        ...cloneDeep(val)
      }

      this.formData = formData;
		}
	},
  methods: {
    submitCommon() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        const formData = {
          ...cloneDeep(this.formData),
          type: 'llm',
        }
        if(this.formData.id) {
          this.$emit('editNode', formData)
        } else {
          this.$emit('addNode', formData)
        }
        this.commonCancel();
      })
    },
    commonCancel() {
      try {
        this.resetFormData();
      } catch (error) {
        // 改成多段录音后 form.resetFields 后报错
        console.log('error :>> ', error);
      }
      this.$emit('change', false)
      this.$emit('cancel');
      this.insertConf = {
        type: '',
        index: 0,
      }
    },
    resetFormData() {
      this.$refs.form.resetFields()
      this.formData = {
        name: '',
        model: '',
        prompt: '',
        dialog: false,
        can_break: true,
        break_delay: 0,
				playback_delay: 0,
        input_timeout: 0,
				tag: '',
				vars: [],
      }
    },
    openAi(type, index) {
      this.insertConf = {
        type,
        index
      }
      setTimeout(() => {
        this.$refs.aiChat.sendMessage('文案优化')
      }, 100)
    },
    onInsert(text) {
      const { index } = this.insertConf
      this.formData.voices[index].text = text;
    },
  },
};
</script>
<style lang="scss" scoped>
.common-container {
  padding: 10px;
  display: flex;
}
.content {
  padding-bottom: 20px;
  display: flex;
  align-items: center;
}
.btn {
  text-align: right;
}
.right {
  width: 300px;
}
</style>